// extracted by mini-css-extract-plugin
export var actionButton = "_km-t";
export var buttonContainer = "_km-0";
export var buttonContainer2 = "_km-1";
export var buttonSection = "_km-2";
export var details = "_km-3";
export var dropdownItem = "_km-5";
export var dropdownItemsContainer = "_km-4";
export var fileInput = "_km-r";
export var headerButton = "_km-6";
export var icon = "_km-7";
export var input = "_km-8";
export var macroListItem = "_km-9";
export var mainContent = "_km-a";
export var microText = "_km-b";
export var modal = "_km-w";
export var optionsButton = "_km-c";
export var paperclip = "_km-s";
export var pillContent = "_km-d";
export var preview = "_km-e";
export var preview2 = "_km-f";
export var quillEditor = "_km-q";
export var selectedMacro = "_km-g";
export var sidebar = "_km-h";
export var sidebarHeader = "_km-j";
export var sidebarList = "_km-i";
export var sidebarListItem = "_km-k";
export var sidebarSearch = "_km-l";
export var snoozeDurationWrapper = "_km-v";
export var statusPillContainer = "_km-m";
export var tagsContainer = "_km-n";
export var unselectedMacro = "_km-o";
export var variable = "_km-u";
export var wrapper = "_km-p";